import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { Observable, range } from 'rxjs';
import { map, filter, toArray } from 'rxjs/operators';

@Component({
    selector: 'is-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: false
})
export class PaginationComponent implements OnInit, OnChanges {
    @Input() limit = 1;
    @Input() offset = 0;
    @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();
    // range determines how many page numbers to show on both sides of current page
    // eslint-disable-next-line no-magic-numbers
    @Input() range = 3;
    @Input() size = 1;
    currentPage: number;
    pages: Observable<number[]>;

    totalPages: number;

    constructor() { }
    cancelEvent(event): void {
        event.preventDefault();
    }
    getCurrentPage(offset: number, limit: number): number {
        return Math.floor(offset / limit) + 1;
    }
    getPages(offset: number, limit: number, size: number): void {
        this.currentPage = this.getCurrentPage(offset, limit);
        this.totalPages = this.getTotalPages(limit, size);
        // range will actually contain the relative offset towards our current page
        this.pages = range(-this.range, this.range * 2 + 1)
            .pipe(
                map((incomingOffset) => this.currentPage + incomingOffset),
                filter((page: number) => this.isValidPageNumber(page, this.totalPages)),
                toArray()
            );
    }
    getTotalPages(limit: number, size: number): number {
        // using Math.max to make sure that both the size and the limit are always at least 1
        return Math.ceil(Math.max(size, 1) / Math.max(limit, 1));
    }
    isValidPageNumber(page: number, totalPages: number): boolean {
        return page > 0 && page <= totalPages;
    }
    ngOnChanges(): void {
        this.getPages(this.offset, this.limit, this.size);
    }
    ngOnInit(): void {
        this.getPages(this.offset, this.limit, this.size);
    }

    selectPage(page: number, event): void {
        this.cancelEvent(event);
        if (this.isValidPageNumber(page, this.totalPages)) {
            this.pageChange.emit((page - 1) * this.limit);
        }
    }
}
